import Tabs, { useTabs } from "../components/atoms/tab";
import React from "react";
import SignScreen from "../components/layout/login/SignScreen";
import { withTabContnet } from "../components/atoms/tab/withTabContent";
import LoginScreen from "../components/layout/login/LoginScreen";

export default function Login() {
    const { currentTab, next, prev } = useTabs(1);
    const SignScreenTab = React.useMemo(() => withTabContnet(SignScreen, {}), []);
    const LoginScreenTab = React.useMemo(() => withTabContnet(LoginScreen, {}), []);


    return (
        <Tabs currentTab={currentTab}>
            <SignScreenTab next={next} />
            <LoginScreenTab prev={prev} />
        </Tabs>

    );
}